import CommandeI18n from './Commande.i18n.js';
import {
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex'
export default {

  components: {},
  computed: {
    ...mapGetters(['cart', 'user', 'fdp']),
    totalCommande() {
      let total = 0
      this.cart.forEach(aArticle => {
        total = total + parseFloat(aArticle.totalProductPrice)
      })
      if (this.shipMode === 'exp' || this.shipMode === 'ce') {
        total = total + parseFloat(this.fdp)
      }
      return total
    },
    totalCommandeWithReduc() {
      let total = 0
      this.cart.forEach(aArticle => {
        total = total + this.prixCaluleLigne(aArticle)
      })
      if (this.shipMode === 'exp' || this.shipMode === 'ce') {
        total = total + parseFloat(this.fdp)
      }
      return total
    }
  },
  props: {},

  data() {
    return {
      name: '',
      email: '',
      phone: '',
      adress: '',
      CP: '',
      city: '',
      comments: '',
      error: false,
      shipMode: 'ret',
      isErreurStripe: false,
      isCE: false,
      paymentMode: 'cb'
    };
  },

  watch: {
    cart(value) {
      const poids = this.getPoidsTotal()
      const total = this.totalCommandeWithReduc
      const info = {
        poids: poids,
        total: total
      }
      this.getFraisDePort(info).then(res => {

      }).catch(err => {
        console.log(err)
      })
    }
  },

  methods: {
    ...mapMutations(['clearCart']),
    ...mapActions(['createCommande', 'getFraisDePort']),
    /**
     * Function to open the order modal.
     */
    openModalOrder() {
      // Check fields
      if ((this.shipMode === 'exp' || this.shipMode === 'ce') && (!this.adress || !this.adress === '' || !this.CP || !this.CP === '' || !this.city || !this.city === '')) {
        this.error = true
      } else {
        this.error = false
        this.$refs['confirm-modal'].show()

      }
    },
    /**
     * Function to close the order modal.
     */
    closeModalOrder() {
      this.$refs['confirm-modal'].hide()
    },
    /**
     * Fonction pour créer la commande et appeler la page de paiement.
     */
    order() {
      let order = {}
      if (this.shipMode === 'exp' || this.shipMode === 'ce') {
        order = {
          userId: this.user.id,
          adresse: this.adress,
          CP: this.CP,
          ville: this.city,
          commentaires: this.comments,
          articles: this.cart,
          mode_livraison: this.shipMode,
          mode_paiement: this.paymentMode
        }
      } else if (this.shipMode === 'ret') {
        order = {
          userId: this.user.id,
          adresse: 'Retrait',
          CP: 'Retrait',
          ville: 'Retrait',
          commentaires: this.comments,
          articles: this.cart,
          mode_livraison: this.shipMode,
          mode_paiement: this.paymentMode
        }
      }
      this.closeModalOrder()
      this.createCommande(order).then(res => {
        if (this.paymentMode === 'cb') {
          const paymentUrl = res.checkout_url
          window.location.href = paymentUrl;
        } else {
          this.$router.push('/commandeSuccess')
        }
      }).catch(err => {
        console.log(err)
        this.isErreurStripe = true
      })
    },

    /**
     * Function to go to cart.
     */
    goToCart() {
      this.$router.push({
        path: `/panier`
      })
    },

    /**
     * Calcul du prix avec la réduction.
     * @returns 
     */
    prixCalcule(pArticle) {
      return pArticle.totalProductPrice * (1 - pArticle.reduction / 100).toFixed(2)
    },
    /**
     * Total d'une ligne.
     * @param {*} pArticle 
     * @returns 
     */
    prixCaluleLigne(pArticle) {
      return pArticle.totalProductPrice * (1 - pArticle.reduction / 100).toFixed(2)
    },

    /**
     * Poids total de la commande.
     * @returns 
     */
    getPoidsTotal() {
      let poids = 0
      this.cart.forEach(aItem => {
        poids = poids + (parseInt(aItem.poids) * aItem.quantite)
      })
      return poids
    }
  },
  filters: {
    currency: (value) => {
      const formatter = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      });
      return formatter.format(value);
    }
  },

  mounted() {
    window.scrollTo(0, 0)
    const poids = this.getPoidsTotal()
    const total = this.totalCommandeWithReduc
    const info = {
      poids: poids,
      total: total
    }
    this.getFraisDePort(info).then(res => {

    }).catch(err => {
      console.log(err)
    })
  },

  i18n: CommandeI18n,

};